<template>
  <div>
    <!-- <topback title="Test" path="/home"></topback> -->

    <card color="#fff">
      <div slot="card-body">
        <h1>sssssss</h1>
      </div>
    </card>

    <navbar></navbar>
  </div>
</template>

<script>
import {Tag} from 'mand-mobile'
import topback from '@/components/topback'
import navbar from '@/components/navbar'
import goodscard from '@/components/goodscard'
import card from '@/components/card'

export default {
  name: 'Test',
  components: {
    Tag,
    [topback.name]: topback,
    [navbar.name]: navbar,
    [goodscard.name]: goodscard,
    [card.name]: card
  },

  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    testaaa() {
      alert("aaaa");
      console.log('testaaa')
    }
  },
}
</script>

<style scoped>
.md-card-button {
  color: #198cff;
  display: inline-block;
  padding: 0.07rem 0.07rem;
  background: #198cff;
  position: relative;
  background: 0 0;
  border-radius: 0.16rem;
  border: 3px solid #198cff;
}
</style>


// WEBPACK FOOTER //
// src/views/test.vue